export class seguimientoEstadoEscrituraModel{

	constructor(		
        public id:MchSeguimientoEstadoId,
		public fecha:Date,
        public cusuario:string,
        public observacion:string,
        public nestado:number
        ){}        
}

export class MchSeguimientoEstadoId{
	constructor(public cid: string ,public videscritura:string, public cnumcont:string, public cprefijo:string){}
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/CrearEscritura/seguimientoEstadoEscritura.model.ts